import { cn } from "@/domains/library"
import { PositionGrid } from "@/domains/settings/components/position-grid"
import { NotificationPosition } from "@/domains/settings/settings-store"

export const PositionCard = ({
  position,
  selectedPosition,
  setSelectedPosition,
  className,
}: {
  position: NotificationPosition
  selectedPosition: NotificationPosition
  setSelectedPosition: (position: NotificationPosition) => void
  className?: string
}) => {
  return (
    <div
      className={cn("flex cursor-pointer flex-col items-center gap-2", className)}
      onClick={() => setSelectedPosition(position)}
    >
      <PositionGrid position={position} selected={selectedPosition === position} />
      <span className={cn("text-sm", selectedPosition === position ? "text-t100" : "text-t300")}>
        {position.replace("-", " ").toLowerCase()}
      </span>
    </div>
  )
}
